import React, { ReactElement } from 'react'
import { Stack, Typography } from '@sureco/design-system'

type ContentPaneProps = {
  title: string
  titleBadge?: React.ReactNode
  children: React.ReactNode
  header?: ReactElement<unknown>
}

export default function ContentPane({
  title,
  titleBadge,
  children,
  header,
}: ContentPaneProps) {
  return (
    <Stack
      space={20}
      borderRadius={8}
      padding={20}
      style={{
        background: '#E0EAF1',
      }}
    >
      <Stack direction="row" align="center" justify="space-between">
        <Stack direction="row" align="center" space={10}>
          <Typography size={16} bold color="#103044">
            {title}
          </Typography>
          {titleBadge}
        </Stack>
        {header}
      </Stack>
      {children}
    </Stack>
  )
}
